import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Heart, Star, ShoppingCart, Check } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import './ProductCard.css';

const ProductCard = ({ product, showRatingAndPrice = true }) => {
  const { t } = useTranslation();
  const { addToCart } = useCart();
  const [added, setAdded] = useState(false);

  const handleAddToCart = () => {
    addToCart(product, 1);
    setAdded(true);
    setTimeout(() => setAdded(false), 1800);
  };

  return (
    <div className="product-card">
      {/* ── Badges row ── */}
      <div className="product-card-top">
        {product.isBestSeller && (
          <span className="badge-text">{t('productCard.bestSeller')}</span>
        )}
        {product.isFeatured && !product.isBestSeller && (
          <span className="badge-text featured">{t('productCard.featured')}</span>
        )}
        <button className="wishlist-btn" aria-label={t('productCard.wishlist')}>
          <Heart size={16} />
        </button>
      </div>

      {/* ── Image ── */}
      <Link to={`/products/${product.slug || product.id}`} className="product-img-link">
        <div className="product-image-container">
          <img
            src={product.imageA ?? product.imageB}
            alt={product.name}
            className="product-image"
            loading="lazy"
          />
        </div>
      </Link>

      {/* ── Divider ── */}
      <div className="product-divider" />

      {/* ── Info ── */}
      <div className="product-info">
        <Link to={`/products/${product.slug || product.id}`} className="product-name-link">
          <h3 className="product-name">{product.name}</h3>
        </Link>

        {(product.shortDesc || product.description) && (
          <p className="product-short-desc">
            {product.shortDesc || product.description}
          </p>
        )}

        {(product.size || product.volume || product.ml) && (
          <span className="product-size">
            {product.size || product.volume || product.ml}
          </span>
        )}

        {showRatingAndPrice && (
          <>
            {/* Rating */}
            <div className="product-rating">
              <div className="stars">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    size={13}
                    fill={i < Math.floor(product.rating ?? 0) ? 'var(--color-primary-gold)' : 'none'}
                    color="var(--color-primary-gold)"
                  />
                ))}
              </div>
              <span className="rating-score">{Number(product.rating ?? 0).toFixed(1)}</span>
              <span className="rating-count">({product.reviews ?? 0})</span>
            </div>

            {/* Price */}
            <div className="product-price">
              {Number(product.price).toLocaleString('vi-VN')}đ
            </div>
          </>
        )}

        {/* Add to bag */}
        <button
          className={`btn-add-bag ${added ? 'added' : ''}`}
          onClick={handleAddToCart}
          aria-label={t('productCard.addToCart')}
        >
          <span className="btn-bag-text">{added ? t('productCard.added') : t('productCard.addToCart')}</span>
          <span className="btn-bag-icon">{added ? <Check size={18} /> : <ShoppingCart size={18} />}</span>
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
